<con-page-layout>
  <con-page-header header="{{ 'appstream.home.welcome_header' | translate }} {{ this.displayName }}">
    <ul class="breadcrumb" *ngIf="currentFolderPath.length > 0">
      <li>{{ "workspaces.current_folder_text" | translate }}</li>
      <li *ngFor="let path of currentFolderPath">
        <span>{{ path }}</span>
      </li>
    </ul>
  </con-page-header>

  <con-page-layout-content>
    <ng-container *ngIf="error; then errorState; else okState"></ng-container>

    <ng-template #errorState>
      <div class="content-container">
        <div class="inner-container">
          <div class="warning-container greeting-container">
            <h4 class="error-page-title">
              <mat-icon class="vertical-align-middle padding-bottom-3">warning</mat-icon>
              {{ "appstream.home.warning_title" | translate }}
            </h4>
            <p>{{ error }}</p>
            <button mat-raised-button (click)="startOver()">
              {{ "appstream.home.start_over_button" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #okState>
      <!-- Invalid/Unexpected user status - show unavailable warning -->
      <ng-container *ngIf="lastUserStatus && !validUserStatuses.includes(lastUserStatus)">
        <div class="content-container">
          <div class="inner-container">
            <div class="warning-container greeting-container">
              <h4 class="error-page-title">
                <mat-icon class="vertical-align-middle padding-bottom-3">warning</mat-icon>
                {{ "appstream.home.warning_title" | translate }}
              </h4>
              <p>{{ "appstream.home.warning_status" | translate }}</p>
              <button mat-raised-button (click)="startOver()">
                {{ "appstream.home.start_over_button" | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Initial loading state -->
      <ng-container *ngIf="lastUserStatus === undefined">
        <div class="content-container">
          <div class="inner-container">
            <h3 class="loadInfo">{{ "appstream.home.waiting_title" | translate }}</h3>
          </div>
        </div>
      </ng-container>

      <!-- User sync in progress -->
      <ng-container *ngIf="lastUserStatus === UserStatus.Waiting">
        <div class="content-container">
          <div class="inner-container">
            <h3 class="loadInfo">{{ "appstream.home.waiting_title" | translate }}</h3>
            <p>{{ "appstream.home.waiting_user_sync_status" | translate }}</p>
            <mat-progress-bar class="loader" mode="indeterminate"></mat-progress-bar>
          </div>
        </div>
      </ng-container>

      <!-- User status is NoUser - show unavailable warning -->
      <ng-container *ngIf="lastUserStatus === UserStatus.NoUser">
        <div class="content-container">
          <div class="inner-container">
            <div class="warning-container greeting-container">
              <h4 class="error-page-title">
                <mat-icon class="vertical-align-middle padding-bottom-3">warning</mat-icon>
                {{ "appstream.home.warning_title" | translate }}
              </h4>
              <p>{{ "appstream.home.warning_status" | translate }}</p>
              <button mat-raised-button (click)="startOver()">
                {{ "appstream.home.start_over_button" | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- User is ready, now check fleet availability -->
      <ng-container *ngIf="lastUserStatus === UserStatus.Ready">
        <!-- Preparing session - waiting for fleet to become available (availableSeats = 0) -->
        <ng-container *ngIf="!fleetStack && !startSessionInProgress">
          <div class="content-container">
            <div class="inner-container">
              <h3 class="loadInfo">{{ "appstream.home.preparing_session_title" | translate }}</h3>
              <p>{{ "appstream.home.preparing_session_status" | translate }}</p>
              <mat-progress-bar class="loader" mode="indeterminate"></mat-progress-bar>
            </div>
          </div>
        </ng-container>

        <!-- Launching session (availableSeats > 0 and auto-start triggered) -->
        <ng-container *ngIf="startSessionInProgress && !!fleetStack">
          <div class="content-container">
            <div class="inner-container">
              <h3 class="loadInfo">{{ "appstream.home.launching_title" | translate }}</h3>
              <mat-progress-bar class="loader" mode="indeterminate"></mat-progress-bar>
              <uilab-button class="button-link" appearance="outlined" (click)="stopSessionStartProcess()">{{
                "appstream.home.cancel_autostart_button" | translate
                }}</uilab-button>
            </div>
          </div>
        </ng-container>

        <!-- Ready to start - fleet available (availableSeats > 0) -->
        <ng-container *ngIf="!startSessionInProgress && !!fleetStack">
          <div class="content-container">
            <div class="inner-container">
              <h4>{{ "appstream.home.start_desktop_title" | translate }}</h4>
              <div class="greeting-container">
                <p>{{ "appstream.home.greetings_text" | translate }}</p>
              </div>
              <uilab-button class="start-button" (click)="startSession()">{{ "appstream.home.start_button" | translate
                }}</uilab-button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>
  </con-page-layout-content>
</con-page-layout>